export default {
  nav: {
    title: 'Tasks',
  }
}
